<template>
  <div>
    <b-modal
      id="modal-signation-digital-application"
      size="lg"
      centered
      :hide-footer="true"
      ref="signationModal"
    >
      <template #modal-title>
        <div class="magenta-title">Gesuch signieren und einreichen</div>
      </template>
      <div>
        <b-alert v-model="hasUnknownError" variant="danger">
          {{ unknownErrorMessage }}
        </b-alert>
        <p>Das Gesuch mit Beilagen ist bereit zum Einreichen.</p>
        <p>Ihr Gesuch gilt erst dann als eingereicht, wenn die notwendigen Beilagen vollständig sind.
        </p>
        <p>Für die Prüfung brauchen wir in der Regel 20 Tage Zeit.</p>
        <b-form-checkbox
          id="application-check"
          v-model="status"
          name="application-check"
          :value="true"
          :unchecked-value="false"
          class="mb-4"
        >
          * Ich bestätige, dass ich für dieses Projekt kein Fördergesuch für Beiträge aus Kompensationsprogrammen gestellt habe. Zum Beispiel
          "myclimate", "KliK", "Energie Zukunft Schweiz" etc. Kommunale Förderprogramme sind von dieser Einschränkung nicht betroffen.
        </b-form-checkbox>
        <p class="mb-2">Bitte bestätigen sie den Hinweistext. Mit Klick auf Button signieren Sie das Gesuch.</p>
        <b-button class="btn btn-green" disabled v-if="isSubmitting">
          <b-spinner small></b-spinner>
          Gesuch signieren und einreichen
        </b-button>
        <b-button class="btn btn-green" :disabled="checkboxChecked" @click="signationApplication" v-else>Gesuch signieren und einreichen</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { errorHandler } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      status: false,
      isSubmitting: false,
      hasUnknownError: false,
      hasError: false,
      unknownErrorMessage: ''
    }),
    props: {
      gesuchId: {
        type: Number
      },
      gesuchKey: {
        type: String
      }
    },
    components: {
    },
    methods: {
      signationApplication () {
        this.isSubmitting = true
        this.hasUnknownError = false
        this.hasError = false

        const formData = {
          gesuchId: this.gesuchId,
          gesuchKey: this.gesuchKey
        }

        this.$store.dispatch('digitalApplication/PROJEKTSTATUS_SIGNATION_CREATE', formData).then(res => {
          const { errors } = res

          if (errors) {
            this.isSubmitting = false
            return errorHandler(this, errors)
          }

          this.isSubmitting = false
          this.$refs.signationModal.hide()
          this.$emit('refresh-application')
          this.$root.$emit('showSignationNotification')
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          this.isSubmitting = false
          console.error(err)
        })
      },
      openModal () {
        this.$refs.signationModal.show()
      }
    },
    computed: {
      checkboxChecked () {
        return !this.status
      }
    }
  }
</script>

<style lang="scss">
#modal-signation-digital-application {
   padding-left: 0 !important;

  .magenta-title {
    color: $magenta;
    font-weight: $font-weight-bold;
  }
}

.icon-gray {
  background-color: $black-10;
  padding: 3px .5rem .5rem;
  border-radius: 0.5rem;
  margin-right: 0.25rem;
}
</style>
